import { configureStore } from '@reduxjs/toolkit';
import filterReducer from './filterSlice'; 

const store = configureStore({
  reducer: {
    filters: filterReducer,
    // Add other reducers here if needed
  },
});

export default store;
